/* convert any string to have capitalized first letter
* ex : smarter vending -> Smarter vending
*/
function firstLetterCapitalized(text: string | undefined):string | undefined {
  if (text) return text.charAt(0).toUpperCase() + text.slice(1);
  return undefined;
}

/* Convert any string of date and compare it with current date.
* For example handleDayChecker('2022-02-01'), if today is 2 Jan 2022 it
* will give output yesterday. Especially using in table that showing
* date like in screens routes->schedule */
const handleDayChecker = (day : string): string => {
  const dateData = new Date(new Date(day).setHours(0, 0, 0));
  const dateToday = new Date(new Date().setHours(0, 0, 0));
  const yesterday = new Date(new Date(new Date().setDate(new Date().getDate() - 1)).setHours(0, 0, 0));
  const tomorrow = new Date(new Date(new Date().setDate(new Date().getDate() + 1)).setHours(0, 0, 0));
  const arrDay = new Date(day).toString().split(' ');
  if (dateToday.getFullYear() === dateData.getFullYear() && dateToday.getMonth() === dateData.getMonth()) {
    if (dateToday.getDate() === dateData.getDate()) return 'Today';
    if (yesterday.getDate() === dateData.getDate()) return 'Yesterday';
    if (tomorrow.getDate() === dateData.getDate()) return 'Tomorrow';
    return `${arrDay[2]} ${arrDay[1]}, ${arrDay[3]}`;
  }
  return `${arrDay[2]} ${arrDay[1]}, ${arrDay[3]}`;
};

/* Would be use full to change Date format to US format date */
const toUSString = (date: Date):string => {
  const arrDate = date.toString().split(' ');
  return `${arrDate[1]}, ${arrDate[2]} ${arrDate[3]}`;
};

/* Checking string is not empty */
const isBlankString = (text: string, result?: string): string | boolean => {
  const spaceRemover = text.replaceAll(' ', '');
  if (spaceRemover === '') {
    if (result) return result;
    return true;
  }
  return false;
};

// Sorter from higher
const sorter = (a: any, b: any): number => {
  if (a === b) return 0;
  if (a > b) return 1;
  return -1;
};

// Render First Name + Last Name
const fullNameHandler = (firstname: string | null, lastname: string | null): string => {
  if (!firstname && !lastname) return '-';
  return `${firstname ? `${firstname} ` : firstname}${lastname ?? ''}`;
};

const getDaysRange = (date: Date | null, otherDate: Date | null):string => {
  if (date && otherDate) {
    const day = Math.ceil(Math.abs(date.getTime() - otherDate.getTime()) / (1000 * 60 * 60 * 24));
    return `${day} Days`;
  }
  return '-';
};

// Date Render 2022-05-06T10:45:14
const formatDate = (date: string | null):string => {
  if (date) {
    const onlyDate = date.split('T')[0].split('-');
    return `${onlyDate[1]}/${onlyDate[2]}/${onlyDate[0]}`;
  }
  return '-';
};

const numberWithZeroInitFormat = (num: number, size: number):string => {
  let zero:string = '';
  for (let i = 0; i < size; i += 1) {
    zero += '0';
  }
  const s = zero + num;
  if (num.toString().length > size) return num.toString();
  return s.substring(s.length - size);
};

export {
  firstLetterCapitalized,
  handleDayChecker,
  toUSString,
  isBlankString,
  sorter,
  fullNameHandler,
  getDaysRange,
  formatDate,
  numberWithZeroInitFormat,
};
